module.exports = __webpack_public_path__ + "static/cover-01-2351d12c574234c414ebaa51298044ee.jpg";